import { render, staticRenderFns } from "./PlatformElderIncreaseTendencyChart.vue?vue&type=template&id=6be75e10&scoped=true&"
import script from "./PlatformElderIncreaseTendencyChart.vue?vue&type=script&lang=js&"
export * from "./PlatformElderIncreaseTendencyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be75e10",
  null
  
)

export default component.exports